import { h } from 'preact';
import style from './style.css';
import Sidebar from '../sidebar';
import * as files from '../../assets/files.json';
const HeaderIsLogin = () => (
  <nav class="navbar navbar-expand-lg bg-body-tertiary">
    <div class="container-fluid">
      <a class="navbar-brand" href="/">
        <img src={files.logo} class={style.logo} alt="logo" />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasNavbar"
        aria-controls="offcanvasNavbar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <Sidebar />
    </div>
  </nav>
);

export default HeaderIsLogin;
